import React from "react";
import { Zap } from "lucide-react";

export function SoWhat({ text, watchNext = [] }) {
  if (!text) return null;
  return (
    <div
      data-testid="so-what-box"
      className="rounded-2xl border border-[#ccff00]/30 bg-[#ccff00]/[0.04] p-6 my-8"
    >
      <div className="flex items-center gap-2 mb-3">
        <Zap className="w-4 h-4 text-[#ccff00]" />
        <span className="font-mono-cl text-xs tracking-[0.24em] text-[#ccff00] uppercase">So What?</span>
      </div>
      <p className="text-zinc-100 text-base sm:text-lg leading-relaxed">{text}</p>
      {watchNext && watchNext.length > 0 && (
        <div className="mt-5 pt-5 border-t border-white/10">
          <p className="font-mono-cl text-[11px] tracking-[0.2em] text-zinc-500 uppercase mb-2">Watch Next</p>
          <div className="flex flex-wrap gap-2">
            {watchNext.map((w, i) => (
              <span key={i} className="px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs text-zinc-300">
                {w}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
